<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <!--Vertical y horizontal-->
          <v-flex xs12 sm8 md6>
            <v-tabs color="blue" dark grow slider-color="yellow">
              <v-tab ripple to="/config/profile">
                Perfil
              </v-tab>
              <v-tab ripple to="/config/account">
                Cuenta
              </v-tab>
            </v-tabs>
            <ChangePassword />
            <br />
            <ChangeEmail id="changeEmail" />
            <br />
            <SyncTelegram />
            <br />
            <DeleteAccount />
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
// @ is an alias to /src
import ChangePassword from "@/components/configAccount/ChangePassword.vue";
import ChangeEmail from "@/components/configAccount/ChangeEmail.vue";
import DeleteAccount from "@/components/configAccount/DeleteAccount.vue";
import SyncTelegram from "@/components/configAccount/SyncTelegram.vue";

//Ajustes de una cuenta
// @group Configurar usuario
export default {
  name: "configAccount",
  components: {
    ChangePassword,
    ChangeEmail,
    DeleteAccount,
    SyncTelegram
  }
};
</script>
